export default "__VITE_ASSET__B0pRZk$q__"